/**
 * Returns false if Reflect, AudioContext or getUserMedia
 * are not supported.
 *
 * @param {Window} _global
 * @returns {boolean}
 */
export default function experienceSupported(_global = self) {
  return (
    typeof _global.Reflect !== "undefined" &&
    typeof (_global.AudioContext || _global.webkitAudioContext) !==
      "undefined" &&
    typeof _global.navigator === "object" &&
    typeof _global.navigator.mediaDevices === "object" &&
    typeof _global.navigator.mediaDevices.getUserMedia === "function" &&
    typeof _global.WebAssembly !== "undefined"
  );
}
